
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormTextarea } from "@/components/FormFields/FormTextarea";
import { FormCheckbox } from "@/components/FormFields/FormCheckbox";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";

interface AdditionalInfoFieldsProps {
  form: UseFormReturn<any>;
  isSubmitting: boolean;
  formErrors: boolean;
}

export function AdditionalInfoFields({ form, isSubmitting, formErrors }: AdditionalInfoFieldsProps) {
  return (
    <>
      <FormTextarea
        form={form}
        name="challenges"
        label="What challenges are you looking to solve with AI?"
        description="Briefly describe any specific challenges your firm is facing"
        placeholder="Brief description of your current challenges..."
        maxLength={500}
        showCount={true}
      />

      <FormTextarea
        form={form}
        name="goals"
        label="What specific outcomes are you hoping to achieve?"
        description="Let us know what success looks like for your firm"
        placeholder="Describe your desired outcomes or goals..."
        maxLength={500}
        showCount={true}
      />

      <FormCheckbox form={form} name="consent">
        Yes, I'd like to receive relevant updates and custom AI solutions information from Docket Labs. <a href="/privacy-policy" className="text-primary hover:underline">Privacy policy</a>.
      </FormCheckbox>

      {formErrors && (
        <Alert variant="destructive" className="bg-destructive/10 border-destructive">
          <InfoIcon className="h-4 w-4" />
          <AlertDescription>
            Please complete all required fields marked with <span className="text-red-500">*</span>
          </AlertDescription>
        </Alert>
      )}

      <Button 
        type="submit" 
        disabled={isSubmitting}
        className="w-full bg-blue-600 hover:bg-blue-700"
      >
        {isSubmitting ? "Submitting..." : "Book My Custom Solutions Call"}
      </Button>
    </>
  );
}
